var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDesktop48Line = function SvgIconDesktop48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v12.8a5.31 5.31 0 0 0 5.3 5.3h7.6v2.6H18v3.4h12v-3.4h-4.2v-2.6h7.6a5.31 5.31 0 0 0 5.3-5.3V14.6a5.31 5.31 0 0 0-5.3-5.3Zm1.9 18.1a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V14.6a1.9 1.9 0 0 1 1.9-1.9h18.8a1.9 1.9 0 0 1 1.9 1.9v12.8Z",
    fill: "current"
  })));
};
export default SvgIconDesktop48Line;